// GraphQL fields to ignore when reporting errors
export const HIDDEN_FIELDS = [
  'email',
  'password',
  'newPassword',
  'confirmPassword',
  'token',
  'phone',
  'ein',
];
